<template>
  <div class="container is-fluid">
    <div class="columns">
      <div class="column">
        <Breadcrumbs :links="links" />
        <div class="actions">
          <a
            href="#"
            class="button is-primary"
            @click.prevent="openEventModal()"
          ><span><PlusCircle /></span>&nbsp;New Event</a>
        </div>
        <div
          v-if="events.length > 0"
        >
        <br>
        <table class="table is-fullwidth">
          <thead>
            <tr>
              <th>Name</th>
              <th>
                <span class="is-flex">
                  Active&nbsp;
                  <span>
                    <HelpCircleOutline
                      v-tooltip="'Defines which is the currently active event'"
                      />
                  </span>
                </span>
              </th>
              <th>Divisions</th>
              <th>Description</th>
              <th>Event dates</th>
              <th>Registration dates</th>
              <td>&nbsp;</td>
            </tr>
          </thead>
          <tbody>
            <EventRow
              v-for="event in events"
              :key="event._id"
              :event="event"
              @updateEvents="getEvents"
              @editEvent="openEventModal"
              @addDivision="openDivisionModal"
              @editDivision="openDivisionEditModal"
            />
          </tbody>
        </table>

        </div>
        <div
          v-else
          class="empty-dashboard"
        >
          <h1 class="is-size-3">No available events</h1>
          <br>
          <img src="@/assets/svg/empty.svg" alt="">
        </div>
      </div>
      <EventModal
        v-if="isOpenEventModal"
        :is-open="isOpenEventModal"
        :type="modalType"
        :initial-data="initialData"
        @closeModal="closeEventModal"
      />
      <DivisionModal
        v-if="isOpenDivisionModal"
        :is-open="isOpenDivisionModal"
        :type="modalType"
        :initial-data="initialData"
        @closeModal="closeDivisionModal"
      />
      <EditDivision
        v-if="isOpenDivisionEditModal"
        :is-open="isOpenDivisionEditModal"
        :type="modalType"
        :initial-data="initialData"
        @closeModal="closeDivisionEditModal"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import PlusCircle from 'vue-material-design-icons/PlusCircle.vue'
import HelpCircleOutline from 'vue-material-design-icons/HelpCircleOutline.vue'
const Breadcrumbs = () => import('@/components/admin/Breadcrumbs')
const EventModal = () => import('@/components/modals/EventModal')
const DivisionModal = () => import('@/components/modals/DivisionModal')
const EditDivision = () => import('@/components/modals/EditDivision')
const EventRow = () => import('@/components/admin/events/EventRow')

export default {
  name: 'Events',
  metaInfo: {
    title: `Events - ${process.env.VUE_APP_PAGE_TITLE}`
  },
  components: {
    Breadcrumbs,
    PlusCircle,
    HelpCircleOutline,
    EventModal,
    EventRow,
    DivisionModal,
    EditDivision
  },
  data () {
    return {
      isOpenDivisionModal: false,
      isOpenDivisionEditModal: false,
      isOpenEventModal: false,
      modalType: 'create',
      initialData: false,
      links: [
        {
          label: 'Dashboard',
          routeName: 'admin-dashboard',
          isActive: false,
          icon: 'dashboard'
        },
        {
          label: 'Events',
          routeName: 'admin-events',
          isActive: true,
          icon: 'trophy'
        }
      ]
    }
  },
  mounted () {
    this.getEvents()
  },
  computed: {
    ...mapGetters('admin', [
      'events'
    ])
  },
  methods: {
    openEventModal (data) {
      if (typeof data !== 'undefined') {
        this.modalType = 'edit'
        this.initialData = data
      } else {
        this.modalType = 'create'
        this.initialData = false
      }
      this.isOpenEventModal = true
    },
    closeEventModal (refresh) {
      this.isOpenEventModal = false
      this.initialData = false
      if (refresh) {
        this.getEvents()
      }
    },
    openDivisionModal (data) {
      if (typeof data !== 'undefined') {
        this.modalType = 'edit'
        this.initialData = data
      } else {
        this.modalType = 'create'
        this.initialData = false
      }
      this.isOpenDivisionModal = true
    },
    closeDivisionModal (refresh) {
      this.isOpenDivisionModal = false
      this.initialData = false
      if (refresh) {
        this.getEvents()
      }
    },
    openDivisionEditModal (data) {
      if (typeof data !== 'undefined') {
        this.modalType = 'edit'
        this.initialData = data
      } else {
        this.modalType = 'create'
        this.initialData = false
      }
      this.isOpenDivisionEditModal = true
    },
    closeDivisionEditModal (refresh) {
      this.isOpenDivisionEditModal = false
      this.initialData = false
      if (refresh) {
        this.getEvents()
      }
    },
    getEvents () {
      this.$store
        .dispatch('admin/GET_EVENTS')
        .then(res => {
          this.$store.commit('admin/saveEvents', res.data.events)
        })
        .catch(err => {
          this.$toasted.error('Server error')
          console.log(err)
        })
    }
  }
}
</script>
